module.exports = __webpack_public_path__ + "static/img/IndAppT01.d612655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/images/znot/IndAppT01.png
// module id = UU2f
// module chunks = 110